import { Grid, Stack, Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { Completed } from "@/components/widgets/completed";
import { Onboarding } from "@/components/widgets/onboarding";
import { RevenueByPaymentStatus } from "@/components/widgets/revenue-by-payment-status";
import { RevenueRecovered } from "@/components/widgets/revenue-recovered";
import { SalesOutstanding } from "@/components/widgets/sales-outstanding";
import { useTrovePlan } from "@/hooks/trove-plan";
import { PricingFeature } from "@/models/backend";

// Charts get a fixed height so they match each other for every account, however much data they hold.
const CHART_HEIGHT = "420px";

export const Route = createFileRoute("/_authenticated/_contained/dashboard")({
  component: Page,
});

function Page(): React.JSX.Element {
  const { features } = useTrovePlan();

  return (
    <Stack spacing={4}>
      <Typography variant="h3">Dashboard</Typography>
      <Grid container spacing={4} columns={{ xs: 6, md: 12 }}>
        {features.includes(PricingFeature.onboarding) && (
          <Grid size={6} sx={{ maxHeight: "520px" }}>
            <Onboarding />
          </Grid>
        )}
        <Grid size={6} sx={{ maxHeight: "420px" }}>
          <RevenueRecovered />
        </Grid>
        <Grid size={6} sx={{ height: CHART_HEIGHT }}>
          <RevenueByPaymentStatus />
        </Grid>
        <Grid size={6} sx={{ height: CHART_HEIGHT }}>
          <SalesOutstanding />
        </Grid>
        <Grid size={6} sx={{ maxHeight: "420px" }}>
          <Completed />
        </Grid>
      </Grid>
    </Stack>
  );
}
